import useAxios from "axios-hooks";
import React from "react";
import FluentSelect from "../../../../Forms/FluentSelect";

const CobrandDropDown = ({
  clientId,
  tagId,
  byNameOrId,
  clients,
  setOptionTable,
  featured,
  isMulti = true,
  ...rest
}) => {
  const getQueryUrl = () => {
    if (clientId) {
      const clientName =
        clients && clients.find((client) => client.clientID === clientId).name;
      return `/internal/client/${clientName}/cobrands`;
    }
    if (tagId) {
      return `/internal/cobrandTags/${tagId}/cobrands`;
    }
    return `/internal/cobrands`;
  };

  const [{ data, loading }] = useAxios({ url: getQueryUrl() });

  let cobrandOptions =
    data &&
    data.map((cobrand) => ({
      value: byNameOrId === "id" ? cobrand.cobrandId : cobrand.name,
      label: cobrand.name,
    }));

    if(featured){
      cobrandOptions && cobrandOptions.unshift({
        value: 17,
        label: 'Enrich Featured',
      },{
        value: 16,
        label: 'iGrad Featured',
      },{
        value: 15,
        label: 'Global Featured',
      })
    }


  return (
    <FluentSelect
      options={cobrandOptions}
      disabled={loading || !clients}
      isMulti={isMulti}
      {...rest}
    />
  );
};
export default CobrandDropDown;
